import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import Swal from 'sweetalert2';

export const createTestimonial = createAsyncThunk(
  'testimonials/createTestimonial',
  async (testimonialData, { rejectWithValue }) => {
    const token = localStorage.getItem('token');
        const role = localStorage.getItem('role');
    
        if (role !== 'superadmin') {
          Swal.fire({
            icon: 'error',
            title: 'Access Denied',
            text: 'Only Superadmin can accept appointments',
          });
          return rejectWithValue('Unauthorized');
        }
    try {
      const response = await axios.post(
        'https://api.thevisaman.in/api/testimonials/create',
        testimonialData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const testimonialSlice = createSlice({
  name: 'testimonials',
  initialState: {
    testimonial: null,
    loading: false,
    error: null,
    message: null,
  },
  reducers: {
    clearTestimonialState: (state) => {
      state.testimonial = null;
      state.loading = false;
      state.error = null;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createTestimonial.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.message = null;
      })
      .addCase(createTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonial = action.payload.data;
        state.message = action.payload.message;
      })
      .addCase(createTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTestimonialState } = testimonialSlice.actions;
export default testimonialSlice.reducer;
